import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Address } from 'src/app/models/address';
import { AddressService } from 'src/app/services/address.service';
import { UserService } from 'src/app/services/user.service';
import { FromAddressComponent } from '../form-address/from-address.component';

@Component({
  selector: 'app-list-address',
  templateUrl: './list-address.component.html',
  styleUrls: ['./list-address.component.scss'],
})
export class ListAddressComponent implements OnInit {

  addresses$: Observable<Address[]>;
  searchQuery$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  selectedAddress$: Observable<Address>;
  private selectedAddressSubject: BehaviorSubject<Address> = new BehaviorSubject<Address>(null);
  popoverOpen = false;
  popoverEvent: any;
  selectedAddress : Address;

  search: string;
  message: string;

  constructor(
    private addressService: AddressService,
    private modalCtrl: ModalController,
    private alertController: AlertController,
    private userService: UserService,
    private toastController: ToastController
  ) { }

  ngOnInit() {
    this.selectedAddress$ = this.selectedAddressSubject.asObservable();

    this.addressService.loadAddresses();

    this.addresses$ = combineLatest([
      this.searchQuery$,
      this.selectedAddress$,
      this.addressService.addresses$
    ]).pipe(
      map(([searchQuery, selectedAddress, data]) => {
        const filteredAddresses = data.filter(address => {
          const name = address.name?.toLowerCase() || '';
          const addresse = address.addresse?.toLowerCase() || '';
          const city = address.city?.toLowerCase() || '';

          return name.includes(searchQuery.toLowerCase()) ||
            addresse.includes(searchQuery.toLowerCase()) ||
            city.includes(searchQuery.toLowerCase());
        });

        // Mettre à jour la propriété showListBtnBox uniquement pour l'adresse sélectionnée
        return filteredAddresses.map(address => {
          if (selectedAddress && address.id === selectedAddress.id) {
            return { ...address, showListBtnBox: selectedAddress.showListBtnBox };
          } else {
            return address;
          }
        });
      })
    );
  }

  async createAddress() {
    const modal = await this.modalCtrl.create({
      component: FromAddressComponent,
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
  }

  async editAddress(address: Address) {
    const modal = await this.modalCtrl.create({
      component: FromAddressComponent,
      componentProps: { address: address }
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();
  }

  async deleteAddress(address: Address) {
    const alert = await this.alertController.create({
      header: 'Confirmation',
      message: `Voulez-vous vraiment supprimer l'adresse ${address.name} ?`,
      buttons: [
        {
          text: 'Annuler',
          role: 'cancel',
          cssClass: 'secondary',
        }, {
          text: 'Supprimer',
          handler: () => {
            this.addressService.deleteAddress(address).subscribe(
              () => {
                this.showToast('Adresse supprimée avec succès');
              },
              () => {
                this.showToast('Erreur lors de la suppression de l\'adresse');
              }
            );
          }
        }
      ]
    });

    await alert.present();
  }

  addressSearch(event: any) {
    this.searchQuery$.next(event.detail.value);
  }
  private async showToast(message: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      buttons: [{ text: 'Ok', role: 'cancel' }]
    });
    await toast.present();
  }

    //PopOver
    openPopover(ev: Event, address : Address) {
      this.popoverEvent = ev;
      this.selectedAddress = address;
      this.popoverOpen = true;

    }
  

}
